import { h } from 'hyperapp'
import Group from './partials/group'
import { expressions } from '../utilities/expessions'

const Buidler = ({ click }) => (
    <aside class="builder">
        {Object.keys(expressions).map((group) => <Group group={expressions[group]} click={click} />)}
    </aside>
)

export default Buidler



// WEBPACK FOOTER //
// ./src/scripts/components/builder.js